import { STORAGE_MANAGEMENT_UPLOAD_DEFAULT_SETTING } from '@picsart/cloud-storage/configs';
import { StorageItemType } from '@picsart/cloud-storage/models';

export enum REMOTE_SETTINGS_TYPES {
  upload_storage_full_popup_config = 'upload_storage_full_popup_config',
  project_duplication_premium = 'project_duplication_premium',
  hop_rollout_settings = 'hop_rollout_settings',
  drive_tools_touchpoint_config = 'drive_tools_touchpoint_config',
  commenting_enabled = 'commenting_enabled',
  show_hidden_files = 'show_hidden_files',
  drive_search_enabled = 'drive_search_enabled',
}

export const DEFAULT_REMOTE_SETTINGS = {
  [REMOTE_SETTINGS_TYPES.upload_storage_full_popup_config]: STORAGE_MANAGEMENT_UPLOAD_DEFAULT_SETTING,
  [REMOTE_SETTINGS_TYPES.drive_tools_touchpoint_config]: undefined,
  [REMOTE_SETTINGS_TYPES.project_duplication_premium]: false,
  [REMOTE_SETTINGS_TYPES.drive_search_enabled]: false,
  [REMOTE_SETTINGS_TYPES.commenting_enabled]: false,
  [REMOTE_SETTINGS_TYPES.show_hidden_files]: false,
  [REMOTE_SETTINGS_TYPES.hop_rollout_settings]: {
    is_enabled: true,
  },
};

export const monetizationPopupProps = {
  touchpoint: 'com.picsart.social.drive',
  source: 'com.picsart.social.drive',
  is_pro_touchpoint: 'pro',
  forceTier: 'pro',
};

export const popupMiniappsIds = {
  fullStorage: 'com.picsart.social.storage-popup',
  invitation: 'com.picsart.social.invitation-screen',
  metaExport: 'com.picsart.social.connectors.prod',
  reporting: 'com.picsart.social.reporting',
  drivePreview: 'com.picsart.social.drive-preview',
  driveMoveTo: 'com.picsart.social.drive-move-to',
};

export const AnalyticsModulesPerSource: Record<string, string> = {
  editor: 'photo_editor',
  create_flow: 'landings',
  my_drive: 'my_drive',
};

export const ANALYTICS_SERVICE_ID = 'GTM-PQ45W6W';
export const ANALYTICS_SERVICE_DATALAYER_NAME = 'dataLayer';

export const ProjectsCrumbData = {
  name: 'Projects',
  type: StorageItemType.FOLDER,
  route: '/workspace',
  itemsCount: 0,
  createdOn: '',
  updatedOn: '',
  spaceUid: '',
};

export const PulseGroupNames = {
  projects: 'projects',
  shared_with_me: 'shared_with_me',
  shared_public: 'shared_public',
};

export const PulseNames = {
  file_not_found: 'file_not_found',
  remove: 'remove',
};

export const editorBaseRoute = '/create/editor';
export const isEditorRoute = '/editor';
